import type { AxiosInstance } from 'axios';
import type { INotificationPreferencesApiPort } from '@personnel/application/ports/INotificationPreferencesApiPort';
import { createNotificationPreferencesHttpClient } from '@personnel/infrastructure/api/NotificationPreferencesHttpClient';
import { mapApiNotificationPreferencesConfigToDto } from '@personnel/infrastructure/mappers/NotificationPreferencesApiMapper';

/**
 * Creates the notification preferences repository.
 *
 * @param props Configuration with Axios HTTP client
 */
export const createNotificationPreferencesApiRepository = (props: {
  httpClient: AxiosInstance;
}): INotificationPreferencesApiPort => {
  const notificationPreferencesHttpClient = createNotificationPreferencesHttpClient(props);

  const getConfig = async () => {
    const entries = await notificationPreferencesHttpClient.getConfig();
    return mapApiNotificationPreferencesConfigToDto(entries);
  };

  return { getConfig };
};
